const BILLING_ADDRESS_FIELDS = [
  "billingStreet1",
  "billingStreet2",
  "billingStreet3",
  "billingStreet4",
  "billingZipCode",
  "billingCity",
  "billingCountry",
];

const SHIPPING_ADDRESS_FIELDS = [
  "shippingStreet1",
  "shippingStreet2",
  "shippingStreet3",
  "shippingStreet4",
  "shippingZipCode",
  "shippingCity",
  "shippingCountry",
];

export function hasInvalidPrefillAddress({
  showBanner,
  sameAsBilling,
  computedOrderValidator,
} = {}) {
  if (!showBanner || !computedOrderValidator) {
    return false;
  }

  const fields = sameAsBilling
    ? BILLING_ADDRESS_FIELDS
    : BILLING_ADDRESS_FIELDS.concat(SHIPPING_ADDRESS_FIELDS);

  return fields.some(
    (field) =>
      computedOrderValidator[field]?.$dirty &&
      computedOrderValidator[field]?.$error,
  );
}
